import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

import { GRADIENT_SEARCH_HEADER } from '@/designSystem/theme';

export default makeStyles()(({ spacing, breakpoints }) => ({
  root: {
    width: '100%',
    background: GRADIENT_SEARCH_HEADER,
  },
  subtitle: {
    marginTop: spacing(2),
  },
  titleContainer: {
    paddingTop: spacing(8),
    [breakpoints.up('md')]: {
      paddingTop: spacing(8),
    },
  },
  searchBarContainer: {
    margin: spacing(4, 0),
    [breakpoints.up('md')]: {
      margin: spacing(5, 0),
    },
    display: 'flex',
    flexDirection: 'column',
    gap: rem(28),
  },
}));
